import { SelectOption } from "../types/select";

export function mapToSelectOptions<TItem>(items: TItem[], config: { labelKey: keyof TItem; valueKey: keyof TItem }) {
  return items.map((item) => ({
    label: String(item[config.labelKey]),
    value: item[config.valueKey],
  })) as SelectOption<TItem[keyof TItem]>[];
}
